import {
  UPDATE_PRODUCT_SETS,
  LOAD_UPGRADE_REPORT_FINALIZE_ORDER,
  EXPAND_PANEL,
  UPDATE_CARD_CONSENT,
  UPDATE_PAYMENT_INFO,
  UPDATE_PROMO_CODE,
  UPDATE_SPECIAL_INSTRUCTIONS,
  UPDATE_CHANGES_IN_4_YEARS,
  PLACE_ORDER,
  GET_ESTIMATED_COST,
  LOAD_FINALIZE_ORDER_PAGE,
  VALIDATE_CREDIT_CARD,
  RESET_FINALIZE_ORDER_PAGE,
  UPDATE_EMAILCC,
  CLEAR_PAYMENT_INFO_ERRORS,
  UPDATE_CLAIM_INFO,
} from 'constants/ActionTypes';

export const updateSpecialInstructions = (value) => ({
  type: UPDATE_SPECIAL_INSTRUCTIONS,
  value,
});

export const updateChangesIn4Years = () => ({ type: UPDATE_CHANGES_IN_4_YEARS });

export const updatePaymentInfo = (paymentInfo) => ({ type: UPDATE_PAYMENT_INFO, paymentInfo });

export const updatePromoCode = (promoCode) => ({ type: UPDATE_PROMO_CODE, promoCode });

export const placeOrder = (transientTokenData) => ({ type: PLACE_ORDER, transientTokenData });

export const loadFinalizeOrderPage = () => ({ type: LOAD_FINALIZE_ORDER_PAGE });

export const getEstimatedCost = (upgradeReportId) => ({ type: GET_ESTIMATED_COST, upgradeReportId });

export const validateCreditCard = () => ({ type: VALIDATE_CREDIT_CARD });

export const updateCreditCardConsent = (ccConsent) => ({ type: UPDATE_CARD_CONSENT, ccConsent });

export const resetFinalizeOrderPage = (isEditOrder) => ({ type: RESET_FINALIZE_ORDER_PAGE, isEditOrder });

export const updateEmailCC = (emailCC) => ({ type: UPDATE_EMAILCC, emailCC });

export const clearPaymentInfoError = () => ({ type: CLEAR_PAYMENT_INFO_ERRORS });

export const expandPanel = (panelName, isExpanded) => ({ type: EXPAND_PANEL, panelName, isExpanded });

export const updateClaimInfo = (claimInfo) => ({ type: UPDATE_CLAIM_INFO, claimInfo });

export const loadUpgradeReportFinalizeOrder = (upgradeReportId, upgradeESX = false) => ({
  type: LOAD_UPGRADE_REPORT_FINALIZE_ORDER,
  upgradeReportId,
  upgradeESX,
});

export const addUpgradeProductSets = (productSets) => ({ type: UPDATE_PRODUCT_SETS, productSets });
